import React from 'react';
import Icon from '@material-ui/core/Icon';
import { AccountStore, Component } from '../../../client';
import { canManageDataTargets } from '../DataDestinations/permissions';
import { CategoryIcon, FlagIcon } from '../../../components/icons';
import SafeNavLink from '../../../components/navigation/SafeNavLink';
import { Page, PageContent, PageHeader } from '../../../components/ux/Page';

const DataDestinationsIcon = (props) => <Icon {...props}>cloud_upload</Icon>;

const AdminLink = ({ caption = '', to = '/', icon: IconComponent }) => {
   return (
      <>
         <SafeNavLink className='admin-link' to={to}>
            <IconComponent className={'admin-icon'} style={{ color: 'white' }} />
            <span>{caption}</span>
         </SafeNavLink>
      </>
   );
};

class AccountPage extends Component {
   constructor(props) {
      super(props);
      this.stores = [AccountStore];
      this.storeKeys = ['authUser'];
   }

   render() {
      return (
         <div className='app-wrapper'>
            <Page className={'AccountPage'}>
               <PageHeader title={'Admin'} subtitle={'Manage your OpsPerfect account'} bar={true} />
               <PageContent margin={'normal'}>
                  <div className='admin-area'>
                     <AdminLink caption={'Change Op Types'} to='/app/account/optypes' icon={CategoryIcon} />
                     <AdminLink caption={'Change Priorities'} to='/app/account/priorities' icon={FlagIcon} />
                     {canManageDataTargets(this.state.authUser) && <AdminLink caption={'Data Destinations'} to='/app/account/data-destinations' icon={DataDestinationsIcon} />}
                  </div>
               </PageContent>
            </Page>
         </div>
      );
   }
}

export default AccountPage;
